import ErrorBoundary from '@/components/ErrorBoundary';
import { StandaloneParagraph } from '@/components/Paragraph';
import { componentClassName } from '@/styles/Paragraph';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata, withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';
import { parseStyle } from 'lib/utils/parseStyle';
import { isString } from 'typesafe-utils';

export const AllasStandaloneParagraph: typeof StandaloneParagraph = ({ content, attributes, options, ...props }) => {
  const className = componentClassName('', {});

  return (
    <ErrorBoundary>
      <p {...attributes} {...mergeProps({ className }, options as any)} {...props} {...withSafeInnerHTML(content)} />
    </ErrorBoundary>
  );
};

const AllasLabradorParagraph: LabradorComponent = ({ type, data, meta, descendants }) => {
  const metaStyle = meta?.attributes?.style;
  if (metaStyle && isString(metaStyle)) {
    meta.attributes.style = parseStyle(metaStyle);
  }

  return (
    <AllasStandaloneParagraph
      content={data.content}
      attributes={meta.attributes}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export const standalone = AllasStandaloneParagraph;

export default AllasLabradorParagraph;
